// Mastermind session config
// ---------------------------
// To point /mastermind at the next session, update the fields below and
// redeploy (commit + push; Netlify rebuilds automatically).
//
//   zoomUrl  – the full Zoom meeting link. Leave as an empty string ('')
//              to force the "no scheduled meeting" page.
//   meetsAt  – when the session starts, as an ISO 8601 string WITH an
//              explicit timezone offset so it's unambiguous.
//              Example (5:00 PM Mountain Daylight Time): '2026-07-23T17:00:00-06:00'
//   timeZone – IANA timezone used to DISPLAY the date/time on the page, so
//              every visitor sees the same wall-clock time regardless of
//              where they are. e.g. 'America/Denver'.
//   redirectLeadMinutes – how many minutes BEFORE meetsAt the page starts
//              auto-redirecting into Zoom. (30 = redirect opens half an hour early.)
//   graceMinutes – how many minutes AFTER meetsAt the auto-redirect stays
//              active. Past this, the page shows "no scheduled meeting."

const mastermind = {
  zoomUrl: 'https://us06web.zoom.us/j/84256760205?pwd=3LHBpz50IzunQhHYIMSzPNIrq23gBu.1',
  meetsAt: '2026-07-23T17:00:00-06:00',
  timeZone: 'America/Denver',
  redirectLeadMinutes: 30,
  graceMinutes: 120,
};

export default mastermind;
